export default {
  'meta': {
    'langName': 'SLOVAK',
    'lang': 'Slovenčina'
  },
  'title': 'STIAHNUTIE PRODUKTU Z PREDAJA: BASKETBALOVÝ KÔŠ B900 BOX NBA TARMAK',
  'description': 'Zistili sme, že pri našom basketbalovom koši B900 hrozí riziko pádu tyče, ak sa kôš používa bez kľuky a manipuluje sa s ním.\nPre vašu vlastnú bezpečnosť okamžite prestaňte produkt používať bez nainštalovanej kľuky na nastavenie výšky.\nSvoj produkt môžete zabezpečiť pomocou jednoduchého postupu a opravnej súpravy, ktorú vám bezplatne doručíme.\nNa tejto webstránke, venovanej stiahnutiu tohto produktu z predaja, sa momentálne pracuje. Prevedie vás jednotlivými krokmi tejto operácie.\nInformovať vás budeme hneď, ako bude dostupná (v priebehu júla).',
  'status': 'Translation validated by COUNTRY'
} as const
